<template>
  <div v-if="localValue.linkGuardSettings">
    <h3 class="subtitle1 text-primary mb-4">
      {{ $t("emailSettings.linkGuardSettings.title") }}
    </h3>
    <v-card class="pa-6">
      <v-checkbox
        v-model="localValue.linkGuardSettings.enabled"
        :disabled="disabled"
        :ripple="false"
        color="primary"
        data-testid="link-guard-enabled-checkbox"
      >
        <template #label>
          <div class="subtitle1" :class="{ 'text-indigo-medium': disabled }">
            {{ $t("emailSettings.linkGuardSettings.enableToggle") }}
          </div>
        </template>
      </v-checkbox>
      <div class="body2 text-indigo-medium ml-9">
        {{ $t("emailSettings.linkGuardSettings.description") }}
      </div>
    </v-card>
  </div>
</template>

<script lang="ts">
import { defineComponent, toRefs } from "vue";
import type { PropType } from "vue";
import type { EmailSecuritySettings } from "@/_store/email-security/email-settings.module";

import { useTwoWayBinding } from "@/composables/useTwoWayBinding.ts";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as PropType<EmailSecuritySettings>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const localValue = useTwoWayBinding(modelValue, (value: EmailSecuritySettings) =>
      emit("update:modelValue", value)
    );

    return {
      localValue,
    };
  },
});
</script>
